import React, {Component} from 'react';

import axios from 'axios'
import {connect} from 'react-redux'
import {locale} from '../locale/AppLocale'
import Config from '../Helpers/Config'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import Loader from '../Components/Loader'
import DropZone from '../Components/DropZone'
import Breadcrumb from '../Components/Breadcrumb'
import ProductInput from "../Components/ProductInput"
import {push as routerPush} from 'react-router-redux'
import {NotificationManager} from '../Helpers/NotificationManager';
import {ValidateProduct,publishErrors} from '../Helpers/ValidateProduct'
import * as productFormActions from "../actions/editProductFormActions"
import ProductAttributesWizard from "../Components/ProductAttributesWizard"
import * as authActions from '../actions/authActions'


import {
    Field,
    FieldArray,
    reduxForm,
    formValueSelector,
    arrayRemoveAll,
    arrayPush,
    touch as touchForm,
    stopAsyncValidation,
    getFormValues
} from 'redux-form'

import {flattenObject} from '../Helpers/flattenObject'
import {FixFormValues} from "../Helpers/FixFormValues";
import {GetEntityAttribute} from "../Helpers/Entity";

const formName = 'editProductForm';
const selector = formValueSelector(formName);


class EditProduct extends Component {


    componentDidMount() {
        this.props.fetchProductForm(this.props.auth.business.id, this.props.match.params.productHashId,'update');
    }

    onSubmit(values) {

        ValidateProduct(values, this.props);

        if (this.props.dirty === false) {
            NotificationManager.warning(locale.get('you_did_not_change_values_to_update_product'));
            return;
        }

        let data = {
            title_ar: GetEntityAttribute(values,'title'),
            description_ar: GetEntityAttribute(values,'description'),
            images: values.images || [],
        };

        this.props.productSpecs.attributes.forEach((group, index) => {
            group.properties.forEach((field, index) => {

                if (typeof values[field.name] === 'undefined') {
                    return ;
                } else {
                    data[field.name] = values[field.name];
                    if (field.data_type === 'dropdown') {
                        if (field.has_other && values[field.name] === -1) {
                            data[field.name + '_other'] = values[field.name + '_other'];
                        } else if (field.is_variant) {

                        } else {
                            data[field.name] = values[field.name];
                        }
                    }
                }
            });
        });

        this.props.toggleFormActionStatus(true);

        axios.post(`${Config.api()}product/update/${this.props.auth.business.id}/${this.props.match.params.productHashId}`, FixFormValues(data),{
            withCredentials:Config.withCredentials()
        }).then((response) => {
            if (!response.data.success) {
                NotificationManager.error(locale.get('an_error_occurred_while_creating_your_product'));
            } else {
                NotificationManager.success(locale.get('product_template_updated_successfully'), GetEntityAttribute(values,'title'));
                this.props.navigateTo(`/${this.props.match.params.businessSlug}/manage`);
            }
            this.props.toggleFormActionStatus(false);
        }).catch((error) => {
            if(error.response.status === 401) {
                this.props.requiresReLogin();
            }else{
                if(error.response.data && error.response.data.message){
                    NotificationManager.error(error.response.data.message);
                }else{
                    NotificationManager.error(locale.get('an_error_occurred_while_creating_your_product'));
                }
            }
            this.props.toggleFormActionStatus(false);

        });

    }

    render() {
        const disabled = this.props.productSpecs.trunk_id && this.props.productSpecs.trunk_id !== this.props.productSpecs.id;

        let hint = null;
        if (disabled) {
            hint = <div className="alert-warning">{ locale.get('cannot_edit_pending_product') }</div>
        }
        return (
            <Loader completed={this.props.productSpecs.fetched}>
                {(() => {
                        if (this.props.productSpecs.fetched === false) {
                            return null
                        }
                        return (
                            <div className="panel-1">
                                <form className="form-horizontal"
                                      onSubmit={this.props.handleSubmit(this.onSubmit.bind(this)) }>
                                    <div className="panel-1--head">
                                        {locale.get('create_product')}
                                    </div>
                                    <div className="panel-1--breadcrumb">
                                        <Breadcrumb items={this.props.productSpecs.breadcrumb}
                                                    prefix={locale.get('product_breadcrumb_prefix')}/>
                                    </div>
                                    {hint}
                                    <div className="panel-1--body">
                                        <div className="inner-content-width">
                                            <div className="tooltip-field" data-scroll-hide={true}
                                                 data-event="click focusin focus"
                                                 data-event-off="focusout" data-tip='' data-tooltip-id='tooltip-title_ar'
                                                 data-iscapture="false" data-place="left" data-effect="solid"
                                                 data-multiline="true">
                                                <Field
                                                    type="text"
                                                    name="title_ar"
                                                    id="title_ar"
                                                    disabled={disabled}
                                                    component={ProductInput}
                                                    className="form-control"
                                                    label={locale.get('product_title_ar')}
                                                    placeholder={locale.get('product_title_ar')}
                                                    field={{}}
                                                    required="required"/>

                                                <ReactTooltip
                                                    id='tooltip-title_ar'>{locale.get('product_tooltip_title')}</ReactTooltip>
                                            </div>
                                            <div className="clearfix"></div>
                                            <div className="tooltip-field"
                                                 data-tip=''
                                                 data-scroll-hide={true}
                                                 data-iscapture={false}
                                                 data-place="left"
                                                 data-html="true"
                                                 data-effect="solid"
                                                 data-tooltip-id={'tooltip-description_ar'}
                                                 data-multiline="true">

                                                <Field
                                                    type="textarea"
                                                    name="description_ar"
                                                    disabled={disabled}
                                                    id="description_ar"
                                                    component={ProductInput}
                                                    className="form-control"
                                                    label={locale.get('product_description_ar')}
                                                    placeholder={locale.get('product_description_ar')}
                                                    field={{data_type: "textarea"}}/>
                                                <ReactTooltip
                                                    id='tooltip-description_ar'>
                                                    <div dangerouslySetInnerHTML={{__html: locale.get('product_tooltip_description_ar')}} />

                                                </ReactTooltip>
                                            </div>
                                            <div className="clearfix"></div>
                                            <FieldArray
                                                component={DropZone}
                                                disabled={disabled}
                                                files={this.props.productSpecs.images}
                                                name="images"
                                                label={locale.get('product_images')}
                                                formName={this.props.form}/>
                                        </div>
                                    </div>


                                    <div className="clearfix"></div>


                                    <ProductAttributesWizard attributes={this.props.productSpecs.attributes}
                                                             action="update"
                                                             disabled={disabled}
                                                             withVariants={false}
                                                             values={this.props.formValues}
                                                             selector={this.props.selector}
                                                             containerProps={this.props}/>


                                    <div className="clearfix"></div>


                                </form>
                            </div>
                        )
                    })()}
            </Loader>
        );
    }
}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    let variants = state.variants;
    if (!variants && state.editProductForm.variantsIndexes.length) {
        variants = selector(state, ...state.editProductForm.variantsIndexes);
        if (Array.isArray(variants)) {
            let tmpVariants = {};
            tmpVariants[state.editProductForm.variantsIndexes[0]] = variants;
            variants = tmpVariants;
        }
    }


    return {
        auth: state.auth,
        productSpecs: state.editProductForm,
        initialValues: state.editProductForm,
        withVariants: false,
        variants: variants,
        formActions: state.formActions,
        productAttributesValues: state.productAttributesWizard,
        selector: (...field) => selector(state, ...field),
        formValues: getFormValues('editProductForm')(state),
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
        fetchProductForm: (businessId, hashId) => dispatch(productFormActions.fetch(businessId, hashId)),
        updateImages: (images) => dispatch(productFormActions.updateImages(images)),
        removeVariants: (index) => dispatch(arrayRemoveAll('editProductForm', 'variants')),
        changeVariants: (fields) => dispatch(arrayPush('editProductForm', 'variants', fields)),
        requireVariantUpdate: (bool) => dispatch(productFormActions.requireVariantUpdate(bool)),
        redirect: (url) => dispatch(routerPush(url)),
        toggleFormActionStatus: (status) => dispatch({
            type: 'FORM_SUBMITTING_CHANGE_STATUS',
            status: status
        }),
        throwErrors: (errors) => {
            let flattenedErrors = flattenObject(errors);
            dispatch(touchForm('editProductForm', ...Object.keys(flattenedErrors)))
            dispatch(stopAsyncValidation('editProductForm', errors))
        },
        requiresReLogin: ()=>dispatch(authActions.requiresRelogin())
    }
};

EditProduct = reduxForm({
    form: formName,
    enableReinitialize: true,
    touchOnChange: true,
    validate: ValidateProduct,
    onSubmitFail:(errors) => {
        publishErrors(errors)
    }
})(EditProduct);

export default connect(mapStateToProps, mapDispatchToProps)(EditProduct);
